/** Requêtes média partagées par toutes les animations. */
export const MOTION_ALLOWED = '(prefers-reduced-motion: no-preference)';
const WIDE_SCREEN = '(min-width: 960px)';
export const WIDE_WITH_MOTION = `${WIDE_SCREEN} and ${MOTION_ALLOWED}`;
